import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Box, Button, Card, TextField, Typography } from "@mui/material";
import axios from "axios";
import { send_messageApi, getAudio } from "../services/backend";
import { io } from "socket.io-client";
import { AppSingleton } from "../services/user_config";

const wsEndpoint = `${process.env.REACT_APP_BACKEND_ENDPOINT}:${process.env.REACT_APP_BACKEND_PORT}`;

const GPTSection = () => {
  const [socket, setSocket] = useState(null);
  const [questionText, setQuestionText] = useState("");
  const [answer, setAnswer] = useState("Please ask question");
  const [currentResponse, setCurrentResponse] = useState({});
  var appSingleton = new AppSingleton();

  useEffect(() => {
    console.log(`start`);
    console.log(wsEndpoint);

    if (socket === null) {
      setSocket(io(wsEndpoint));
    }

    if (socket) {
      socket.on("connect", () => {
        console.log("Connected to server");
      });
      socket.on("disconnect", () => {
        console.log("XXX Disconnected from server");
      });

      socket.on("message", (resp) => {
        console.log(resp);
        if (resp.status === "messaging") {
          // setIncoming(resp.data);
          console.log("incoming");
          console.log(resp.data);
          appSingleton.gpt_pending_pool.push(resp.data);
          nextMessage();
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    console.log("currentResponse");
    console.log(currentResponse);
    if (Object.keys(currentResponse).length > 0) {
      setAnswer(answer.toString() + currentResponse.text.toString());
      getAudio({ uid: currentResponse.uid }).then((_audio) => {
        appSingleton.currentAudioSource = _audio;
        console.log(`start playing: ${appSingleton.currentAudioSource}`);
        appSingleton.currentAudioSource.addEventListener("ended", function () {
          console.log("ended");
          nextMessage();
        });
        appSingleton.currentAudioSource.play();
      });
    }
  }, [currentResponse]);

  const nextMessage = () => {
    console.log("appSingletn.currentAudioSource");
    console.log(appSingleton.currentAudioSource);
    console.log("appSingleton.gpt_pending_pool");
    console.log(appSingleton.gpt_pending_pool);
    if (
      appSingleton.currentAudioSource == null ||
      appSingleton.currentAudioSource?.ended
    ) {
      if (appSingleton.gpt_pending_pool.length > 0) {
        const next = appSingleton.gpt_pending_pool.shift();
        console.log("next");
        console.log(next);
        setCurrentResponse(next);
      }
    }
  };

  const getAnswer = async () => {
    setAnswer("");
    appSingleton.gpt_pending_pool = [];
    // setPendingPool([]);
    const response = await send_messageApi({ message: questionText });
  };

  return (
    <>
      <Card sx={{ width: "100%" }}>
        <TextField
          id="outlined-basic"
          label="Outlined"
          variant="outlined"
          fullWidth
          value={questionText}
          onChange={(evt) => setQuestionText(evt.target.value)}
        />
      </Card>
      <Box textAlign="center">
        <Button variant="contained" onClick={getAnswer}>
          Send
        </Button>
      </Box>
      {/* {parse({ answer })} */}
      {answer}
    </>
  );
};

const f = () => {};

export { GPTSection, f };
